import {
  DialogPositionStrategyInIframe,
  ENVIRONMENTS,
  RETAILERS,
} from '@shared/constants';
import { Environment } from '@shared/models';

import '@angular/common/locales/global/fr';

export const environment: Environment = {
  lang: 'fr-FR',
  maxReward: 50,
  production: true,
  maintenance: false,
  hasCampaignBis: true,
  hasBisPage: false,
  baseHref: '/fr/',
  maxSelectedChallenges: 10,
  showMaxSelectedBisModal: false,
  env: ENVIRONMENTS.STAGING,
  retailerName: RETAILERS.CETOINE,
  projectType: 'loyaltyChallenge',
  cloudFlareTurnstileKey: '1x00000000000000000000AA',
  backendUrl: 'https://b2c.challengefid.ai.eagleeye.com/api/v2',
  dialogPositionStrategyInIframe: DialogPositionStrategyInIframe.DEFAULT,
  enableSentry: true,
  enableABTest: true,
  ssrAllowedHosts: ['*.uat.ai.eagleeye.com'],
};
